import { TooltipChord, TooltipScale } from '../components';

import Abc from './abc';
import GoToLink from './gotolink';
import Group from './group';
import Image from '../components/image';
import InstrumentContent from './instrument-content';
import { Interval } from "@tonaljs/tonal";
import KeyWrapper from './keywrapper';
import { Link } from '@reach/router';
import { default as Markdown2Jsx } from 'markdown-to-jsx';
import Notes from './notes';
import Player from './Player/Player';
import Player2 from './player2';
import React from 'react';
import ScaleTones from './scaletones';
import Score from './score';
import ScoreSvg from './score-svg';
import Tone from './tone';
import { transposeToInstrumentKey } from '../lib/transposeKey';
import { useGlobalState } from '../state';

var keyRegEx = /([A-G]{1}(?:[#b]?))?(m?)/;

const Markdown = ({ objectProps, children }) => {
  const [currentInstrument] = useGlobalState('instrument');
  const [currentInstrumentClef] = useGlobalState('instrumentClef');
  let semiTonesDiff = 0;
  
  const getKeyTonic = (value) => {
    if (!value) {
      return "";
    }
    let keyMatch = value.match(keyRegEx);
    if (keyMatch !== null) {
      return keyMatch[1];
    }
    return "";
  }
  const getKeyQuality = (value) => {
    if (!value) {
      return "";
    }
    let keyMatch = value.match(keyRegEx);
    if (keyMatch !== null) {
      return keyMatch[2];
    }
    return "";
  }

  let keytonic = getKeyTonic(objectProps?.keytonic);
  const keyquality = getKeyQuality(objectProps?.keytonic);
  // Song (or Fact with that is markt to do intrument transponation)
  if (objectProps?.skipInstrumentTransponation !== true) {
    // Adjust exercise key this BEFORE changing the keytonic.
    // Exercise with keytonic defined, calculate semitones diff for player transponation based on difference between exercise key and selected keytonic
    if(objectProps?.org_keytonic){
      const keyDiff =Interval.semitones(Interval.distance(objectProps?.org_keytonic, keytonic));
      const wrapped = ((keyDiff + 6) % 12) - 6; // Shortest distance between keys, e.g. -2 instead of +10
      semiTonesDiff += wrapped;
      //console.log("org_keytonic "+objectProps?.org_keytonic+" vs keytonic "+keytonic+" with keydiff "+keyDiff+" wrapped to "+wrapped+" resulting in semitones diff "+semiTonesDiff);
    }
    
    // Change key tonic based on selected instrument
    // Will the displayed keytonic in notation and tooltips, but not the sound of midi files
    keytonic = transposeToInstrumentKey(currentInstrument, keytonic, keyquality !== 'm');
  }
  // Fact (with default setting to skip intrument transponation)
  else {
    // Calculate semitones diff for player transponation based on selected instrument
    // Will change the sound of midi files, but not the displayed keytonic in notation and tooltips
    switch(currentInstrument){
      case "Bb":
        semiTonesDiff = -2;
        break;
      case "Eb":
        semiTonesDiff = +3;
        break;
      default:
        semiTonesDiff = 0;
    }
    // Exercise with keytonic defined, calculate semitones diff for player transponation based on difference between exercise key and selected keytonic
    if(objectProps?.org_keytonic){
      const keyDiff =Interval.semitones(Interval.distance(objectProps?.org_keytonic, keytonic));
      const wrapped = ((keyDiff + 6) % 12) - 6; // Shortest distance between keys, e.g. -2 instead of +10
      semiTonesDiff += wrapped;
      //console.log("org_keytonic "+objectProps?.org_keytonic+" vs keytonic "+keytonic+" with keydiff "+keyDiff+" wrapped to "+wrapped+" resulting in semitones diff "+semiTonesDiff);
    }
  }

  if (typeof children !== 'string') {
    return null;
  }
  children += "\n\n";

  return (
    <Markdown2Jsx
      children={children}
      options={{
        forceInline: true,
        overrides: {
          abc: {
            component: Abc,
            props: {
              t: keytonic,
              clef: currentInstrumentClef
            }
          },
          instrument: {
            component: InstrumentContent,
            props: {
              t: keytonic,
              instrument: currentInstrument
            }
          },
          key: {
            component: KeyWrapper,
            props: {
              t: keytonic
            }
          },
          sc: {
            component: TooltipScale,
            props: {
              t: keytonic,
              pop: true,
              clef: currentInstrumentClef
            }
          },
          scale: {
            component: TooltipScale,
            props: {
              t: keytonic,
              pop: false,
              clef: currentInstrumentClef
            }
          },
          ch: {
            component: TooltipChord,
            props: {
              t: keytonic,
              pop: true,
              clef: currentInstrumentClef
            }
          },
          chord: {
            component: TooltipChord,
            props: {
              t: keytonic,
              pop: false,
              clef: currentInstrumentClef
            }
          },
          image: {
            component: Image
          },
          go: {
            component: GoToLink
          },
          group: {
            component: Group
          },
/*           notes: {
            component: Notes,
            props: {
              t: keytonic
            }
          }, */
          notes: {
            component: Notes,
            props: {
              t: keytonic,
              org_keytonic: getKeyTonic(objectProps?.keytonic),
              q: keyquality,
              instrument: currentInstrument,
              clef: currentInstrumentClef,
              skipInstrumentTransponation: objectProps?.skipInstrumentTransponation
            }
          },
          score: {
            component: Score,
            props: {
              t: keytonic,
              q: keyquality,
              transpose: semiTonesDiff,
              ...objectProps?.scoreProps
            }
          },
          scoresvg: {
            component: ScoreSvg,
            props: {
              t: keytonic,
              q: keyquality,
              ...objectProps?.scoreProps
            }
          },
          t: {
            component: Tone,
            props: {
              t: keytonic
            }
          },
          /*                   st: {
                              component: ScaleTones,
                              props:{
                                t: keytonic
                              }
                            }, */
          player: {
            component: Player,
            props: {
              transpose: semiTonesDiff,
            ...objectProps
            }
          },
          /* p1: {
            component: Player2,
            props: {
              midiEditor: true
            }
          }, */
        },
      }}
    />
  );
}

export default Markdown;